import { supabase } from '../supabaseClient';

export const PortalMessagesService = {
  async listThreads(clientId) {
    if (!clientId) return { data: [], error: new Error('Missing client id') };
    try {
      const { data, error } = await supabase
        .from('communication_history')
        .select(`
          id,
          case_id,
          subject,
          summary,
          comm_type,
          direction,
          created_at,
          read_at,
          metadata
        `)
        .eq('client_id', clientId)
        .order('created_at', { ascending: false })
        .limit(50);
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalMessagesService] listThreads failed', error);
      return { data: [], error };
    }
  },

  async sendMessage(payload) {
    try {
      const { data, error } = await supabase
        .from('communication_history')
        .insert({
          client_id: payload.clientId,
          case_id: payload.caseId || null,
          submission_id: payload.submissionId || null,
          subject: payload.subject || 'Portal message',
          summary: payload.body?.slice(0, 140) || 'Client update',
          full_content: payload.body,
          comm_type: 'portal',
          direction: 'outbound',
          metadata: payload.metadata || {}
        })
        .select()
        .single();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('[PortalMessagesService] sendMessage failed', error);
      return { data: null, error };
    }
  },

  async getUnreadCount(clientId) {
    if (!clientId) return { data: 0, error: null };
    try {
      const { count, error } = await supabase
        .from('communication_history')
        .select('id', { count: 'exact', head: true })
        .eq('client_id', clientId)
        .eq('direction', 'inbound')
        .is('read_at', null);
      if (error) throw error;
      return { data: count || 0, error: null };
    } catch (error) {
      console.error('[PortalMessagesService] getUnreadCount failed', error);
      return { data: 0, error };
    }
  }
};
